module.exports = __webpack_public_path__ + "static/media/maybe-one-day.4e6ff350.mp3";